import CopyToClipboard from "components/CopyToClipboardButton";
import React from "react";

const styles = require("./style.less");

const CopyValueToClipboard: React.FC<{ value: string }> = ({ value }) => {
    return (
        <div className={styles.copyValue}>
            <strong>{value}</strong>
            <CopyToClipboard value={value} />
        </div>
    );
};

export default CopyValueToClipboard;
